export enum ContentDiscoveryMenuItemType {
    ConvoStream = 'convo-stream',
    Convo = 'convo',
    Custom = 'custom',
    Channel = 'channel',
}
